<svg viewBox="0 0 100 100">
  <g>
    <circle class="background" cx="50%" cy="50%" [attr.r]="radius" [attr.stroke-dasharray]=dasharray
            [attr.stroke-width]="widthPercent+'%'"
            fill="transparent"></circle>

    <circle class="progress" cx="50%" cy="50%" [attr.r]="radius" [attr.stroke-dasharray]=dasharray
            [attr.stroke-dashoffset]="offset" [attr.stroke-width]="widthPercent+'%'"
            fill="transparent"></circle>
  </g>
</svg>
